import { useState } from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TableSortLabel
} from "@mui/material";
import { Token } from "../entities/token";

export interface TokensProps {
    tokens: Token[];
    showAdminInfos?: boolean;
}

export const Tokens = ({ tokens, showAdminInfos = false }: TokensProps) => {
    const [order, setOrder] = useState<'asc' | 'desc'>('asc');
    const [orderBy, setOrderBy] = useState<string>('id');

    const handleRequestSort = (property: string) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const sortedTokens = [...tokens].sort((a: any, b: any) => {
        if (a[orderBy] < b[orderBy]) return order === 'asc' ? -1 : 1;
        if (a[orderBy] > b[orderBy]) return order === 'asc' ? 1 : -1;
        return 0;
    });

    return (
        <TableContainer>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>
                            <TableSortLabel
                                active={orderBy === 'id'}
                                direction={orderBy === 'id' ? order : 'asc'}
                                onClick={() => handleRequestSort('id')}
                            >
                                ID
                            </TableSortLabel>
                        </TableCell>
                        <TableCell>
                            <TableSortLabel
                                active={orderBy === 'isPaidToken'}
                                direction={orderBy === 'isPaidToken' ? order : 'asc'}
                                onClick={() => handleRequestSort('isPaidToken')}
                            >
                                Paid token
                            </TableSortLabel>
                        </TableCell>
                        <TableCell>
                            <TableSortLabel
                                active={orderBy === 'createdAt'}
                                direction={orderBy === 'createdAt' ? order : 'asc'}
                                onClick={() => handleRequestSort('createdAt')}
                            >
                                Creation date
                            </TableSortLabel>
                        </TableCell>
                        {showAdminInfos && (
                            <>
                                <TableCell>
                                    <TableSortLabel
                                        active={orderBy === 'createdBy'}
                                        direction={orderBy === 'createdBy' ? order : 'asc'}
                                        onClick={() => handleRequestSort('createdBy')}
                                    >
                                        Created by
                                    </TableSortLabel>
                                </TableCell>
                                <TableCell>
                                    <TableSortLabel
                                        active={orderBy === 'lastModifiedAt'}
                                        direction={orderBy === 'lastModifiedAt' ? order : 'asc'}
                                        onClick={() => handleRequestSort('lastModifiedAt')}
                                    >
                                        Update date
                                    </TableSortLabel>
                                </TableCell>
                                <TableCell>
                                    <TableSortLabel
                                        active={orderBy === 'lastModifiedBy'}
                                        direction={orderBy === 'lastModifiedBy' ? order : 'asc'}
                                        onClick={() => handleRequestSort('lastModifiedBy')}
                                    >
                                        Update user
                                    </TableSortLabel>
                                </TableCell>
                            </>
                        )}
                        <TableCell>
                            <TableSortLabel
                                active={orderBy === 'status'}
                                direction={orderBy === 'status' ? order : 'asc'}
                                onClick={() => handleRequestSort('status')}
                            >
                                Status
                            </TableSortLabel>
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {sortedTokens.map((token) => (
                        <TableRow hover key={token.id}>
                            <TableCell>{token.id}</TableCell>
                            <TableCell>{token.isPaidToken ? "PAID" : "FREE"}</TableCell>
                            <TableCell>{new Date(token.createdAt).toLocaleString("fr-be")}</TableCell>
                            {showAdminInfos && (
                                <>
                                    <TableCell>{token.createdBy}</TableCell>
                                    <TableCell>{new Date(token.lastModifiedAt).toLocaleString("fr-be")}</TableCell>
                                    <TableCell>{token.lastModifiedBy}</TableCell>
                                </>
                            )}
                            <TableCell>{token.status}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};